import React, { useContext } from 'react';
import { Button } from '@shopify/polaris';
import { QuestionContext } from '../contexts/Question';

export default function StuddyAI(props) {

  const editing = props.editing || false;
  const studdyai_jwt = props.studdyai_jwt;
  const label = props.label || "StuddyAI";

  // Parse text and find images, return array of urls and mime types
  const findImgNodes = (content, images, isString) => {
    if (isString) {
      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(content, 'text/html');
    } else {
      htmlDoc = content;
    }
    htmlDoc.childNodes.forEach(function(node) {
      if (node.nodeName === "IMG") {
        var ext = node.src.split('.')[node.src.split('.').length-1];
        if (ext === 'jpg') { ext = 'jpeg'; }
        if (ext.length > 4) { ext = 'png'; }
        var mimeType = 'image/' + ext;
        images.push({file_uri: node.src, mime_type: mimeType});
        console.log(node.src);
      }
      if (node.childNodes.length > 0) {
        findImgNodes(node, images, false);
      }
    });
    return images;
  }

  const onStuddyAIClick = () => {

    let question_name = '', 
      question_text = '', 
      correct_answer_text = '', 
      ai_instructions = '', 
      answers = [];

    if (editing) {
      question_name = $("input#question_name").val();
      question_text = $("#question_text").val();
      if ($("input:checked").length > 0) {
        correct_answer_text = $($("input:checked").parents(".answer").find("textarea")[0]).val();
      }
      ai_instructions = $("#ai_instructions").val();
      answers = $(".answer:visible").map((i, a) => {return $(a).find("textarea")[0].value;}).get();
    } else {
      question_name = $("h2.Polaris-Heading").html();;
      question_text = $("#question_text_preview").html();
      if ($("span.check").length > 0) {
        correct_answer_text = $("span.check").siblings()[0].innerHTML;
      }
      ai_instructions = $("#ai_instructions_preview").html() || '';
      answers = $("#answers_preview .answer").map((i, a) => {return $(a).html();}).get();
    }
    if (question_name.length === 0) { question_name = "New Question"; }

    let question_id = question_name.split('#')[1] || props.question_id;
    let topic_name = question_name.split(':')[0].trim();

    // Question content array of text and img hashes
    let problemArray = [];
    problemArray.push({type: 'text', text: question_text});
    findImgNodes(question_text, [], true).forEach(function(image) {
      problemArray.push({type: "image", file_data: image});
    });
    if (ai_instructions.length > 0) {
      problemArray.push({type: 'text', text: ai_instructions})
    }

    // Answers content array of arrays of text and img hashes
    let answersArray = [];
    let answerLabel = 0;
    answers.forEach((answer) => {
      let answerContent = [];
      answerContent.push({type: 'text', text: answer});
      findImgNodes(answer, [], true).forEach((image) => {
        answerContent.push({type: "image", file_data: image})
      });
      answerLabel++;
      answersArray.push({label: answerLabel, contents: answerContent});
    });

    // Correct answer content array of text and img hashes
    let correctAnswerArray = [];
    if (correct_answer_text.length > 0) {
      correctAnswerArray.push({type: 'text', text: correct_answer_text});
      findImgNodes(correct_answer_text, [], true).forEach((image) => {
        correctAnswerArray.push({type: "image", file_data: image})
      });
    }

    // StuddyAI payload
    let data = {problems:
      [{
        problemId: question_id,
        referenceTitle: question_name,
        problemStatement: problemArray,
        solutionOptions: answersArray,
        contextModifiers: {
          solution: correctAnswerArray,
          tableOfContents: {
            currentSectionName: topic_name
          }
        }
      }]
    };
    console.log("StuddyAI data: ", data);
    // Set widget data
    studdyWidget.setPageData(data);

    // Make sure we can display widget
    try {
      studdyWidget.enlarge('solver');
      studdyWidget.display();
    
    // If we can't display the widget, authenticate
    } catch(error) {
      studdyWidget.authenticate({
        authMethod: "jwt", tenantId: "thinkwell", jwt: studdyai_jwt
      })
      .then(function(response) {
        studdyWidget.setPageData(data);
        studdyWidget.enlarge('solver');
        studdyWidget.display();
      })
      .catch(function(error) { console.error("Unable to authenticate StuddyAI."); });
    }
  }

  // Hide default widget icon
  window.addEventListener("message", function(event) {
    if (event.data.type === 'WIDGET_MINIMIZED') {
      studdyWidget.hide();
    }
  });

  return (
    <Button plain onClick={onStuddyAIClick}>{label}</Button>
  )

}